import styled from 'styled-components'
import theme from '@app/ui/theme'
import { fieldInputStyles } from '@app/components/molecules/FormFields/styled'

export const Title = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
`

export const Subtitle = styled.p`
  margin: 4px 0 0 0;
  font-size: 14px;
  color: #666;
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 16px;
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const SectionLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #888;
`

export const KindGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`

export const CountRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const CountChip = styled.button<{ isSelected: boolean }>`
  min-width: 56px;
  height: 40px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid
    ${(props) => (props.isSelected ? theme.colors.secondary2 : '#e4e4e4')};
  background-color: ${(props) =>
    props.isSelected ? theme.colors.secondary2 : theme.colors.white};
  font-size: 15px;
  font-weight: ${(props) => (props.isSelected ? 700 : 500)};
  color: ${(props) =>
    props.isSelected ? theme.colors.white : theme.colors.black};
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:hover {
    border-color: ${theme.colors.secondary2};
  }
`

export const Hint = styled.span`
  font-size: 13px;
  color: #666;
`
